import SurveyViewList from "@/features/survey-views/list";

const SurveyViews = () => {
  return <SurveyViewList />;
};

export default SurveyViews;
